/**
 * Citation and reference URLs are derived from LLM output and taxpayer-filed
 * text, so they are untrusted. Rendering one straight into an `href` allows a
 * `javascript:` (or `data:`) URL to execute on click — DOM-based XSS. This
 * allowlists http(s) only; anything else yields `undefined`, so the caller
 * renders plain text instead of a live link.
 */
export function safeHref(url: string | null | undefined): string | undefined {
  if (!url) return undefined
  const trimmed = url.trim()
  try {
    const parsed = new URL(trimmed, window.location.origin)
    if (parsed.protocol === "http:" || parsed.protocol === "https:") {
      return parsed.href
    }
  } catch {
    // Not a parseable absolute/relative URL — never emit it as an href.
  }
  return undefined
}
